<template>
	<div class="col carousel__item js-carousel__item" :id="'card-' + id">
		<component
			:is="tagType"
			class="card card--with-image"
			:href="displayWithLink ? link : ''"
		>
			<div
				v-if="!showSimpleView && responsiveImageThreeColumns"
				class="hotspot-list__image card__image"
				v-html="responsiveImageThreeColumns"
			></div>
			<div
				v-else-if="!showSimpleView"
				class="hotspot-list__image card__image"
				v-html="LeafPatternLarge"
			></div>

			<span class="card__icon" v-html="Document"> </span>

			<div class="hotspot-list__container">
				<p
					class="hotspot-list__date"
					:class="showSimpleView ? 'hotspot-list__date--simple' : ''"
					:aria-describedby="id"
				>
					{{ dateText }}
				</p>
				<h3
					:id="id"
					class="body-text--small bold card__title hotspot-list__headline"
				>
					{{ title }}
				</h3>
				<p class="card__manchet">{{ manchet }}</p>
			</div>
		</component>
	</div>
</template>

<script setup>
</script>

<script setup>
import { computed } from 'vue';
import LeafPatternLarge from "../../../views/visuals/leafPatternLarge.cshtml";
import Document from "../../../views/icons/document.cshtml";
import { defineProps } from 'vue';

const props = defineProps({
	id: {
		type: String,
		default: ""
	},
	title: {
		type: String,
		default: ""
	},
	responsiveImageThreeColumns: {
		type: String,
		default: ""
	},
	link: {
		type: String,
		default: ""
	},
	manchet: {
		type: String,
		default: ""
	},
	dateText: {
		type: String,
		default: ""
	},
	disableLink: {
		type: Boolean,
		default: false
	},
	showSimpleView: {
		type: Boolean,
		default: false
	}
});

const displayWithLink = computed(() => {
	return props.link && !props.disableLink;
});

const tagType = computed(() => {
	return displayWithLink.value ? "a" : "div";
});
</script>
